import { fetchQuery, graphql } from "relay-runtime"
import {
  insureeDataFromSasisBySocialSecurityNumberQuery,
  insureeDataFromSasisBySocialSecurityNumberQuery$data,
} from "@/modules/admin/sasis-lookup/services/__generated__/insureeDataFromSasisBySocialSecurityNumberQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query insureeDataFromSasisBySocialSecurityNumberQuery($socialSecurityNumber: String!) {
    ch_insureeDataFromSasisBySocialSecurityNumberAtEveryInsurer(socialSecurityNumber: $socialSecurityNumber) {
      organisationResults {
        nationalInsuranceNumber
        organisationName
        errorMessage
        result {
          mapped {
            firstName
            lastName
            dateOfBirth
            gender
            insureeNumber
            insuranceCardNumber
            socialSecurityNumber
            healthInsurance
            nationalInsuranceNumber
            isPrimary
            gatekeeperZsr
            validFrom
            validTo
            address {
              houseNumberStreet
              city
              postalCode
              countryCode
            }
          }
          rawXml
          returnCode
          returnMessage
        }
      }
    }
  }
`

export type InsureeDataFromSasisAtEveryInsurer =
  insureeDataFromSasisBySocialSecurityNumberQuery$data["ch_insureeDataFromSasisBySocialSecurityNumberAtEveryInsurer"]

export const fetchInsureeDataFromSasisBySocialSecurityNumber = (
  socialSecurityNumber: string,
): Promise<InsureeDataFromSasisAtEveryInsurer | null> =>
  fetchQuery<insureeDataFromSasisBySocialSecurityNumberQuery>(
    RelayEnvironment,
    query,
    { socialSecurityNumber },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => response?.ch_insureeDataFromSasisBySocialSecurityNumberAtEveryInsurer ?? null)
